import useI18n from './useI18n';
import { ABOUT_CONTENT } from '../data/aboutContent';

/**
 * Resolves the "Chi sono" page copy for the current UI language from the
 * static ABOUT_CONTENT map (see src/data/aboutContent.js) — previously
 * fetched from a MongoDB-backed CMS. Same `t(key, fallback)` API as before.
 */
export default function useAboutContent() {
  const { lang } = useI18n();
  const blocks = ABOUT_CONTENT[lang] || ABOUT_CONTENT.it;

  const t = (key, fallback = '') => {
    const v = blocks[key];
    if (v !== undefined && v !== null && v !== '') return v;
    return fallback;
  };

  return { t, blocks, loaded: true };
}
